import { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { loginRequest } from '../authConfig';
import { useMsal } from "@azure/msal-react";

const useSignalR = (hubUrl) => {
  const [message, setMessage] = useState({});
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const fetchData = async () => {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });

      const connection = new signalR.HubConnectionBuilder()
        .withUrl(hubUrl, {
          accessTokenFactory: () => response.accessToken, // Gửi token nếu có authentication
        })
        .withAutomaticReconnect()
        .build();

      connection.start()
        .then(() => console.log("SignalR Connected"))
        .catch(err => console.error("SignalR Connection Error:", err));

      connection.on("ReceiveMessage", (id, name, photo) => {
        setMessage({ id, name, photo });
      });

      return () => {
        connection.stop();
      };
    }
    fetchData();
  }, [hubUrl]);

  return message;
};

export default useSignalR;
